<template>
    <ButtonPopover v-if="items.length">
        <template #button="{ open }">
            <slot name="button" :open="open" />
        </template>
        <template #content>
            <div class="flex flex-col min-w-32 w-fit">
                <template v-for="(item, i) in items">
                    <div v-if="item.type == 'divider'" class="bg-border h-px mx-auto w-full" />
                    <div v-else :class="[
                        'flex items-center gap-x-2 relative text-lg font-header font-semibold',
                        iconExists ? 'pr-6 pl-10' : '',
                    ]">
                        <component v-if="item.icon" :is="item.icon" class="absolute left-1 size-7" />
                        <DynamicLink v-if="item.type == 'link'" :href="item.href" :data="item.data || {}"
                            class="w-full focus-style cursor-pointer underline-hover p-2" v-text="item.text" />
                        <PopoverButton v-else-if="item.type == 'button'" :disabled="item.disabled ?? false"
                            @click="item.action" class="w-full text-left focus-style p-2" :class="[
                                {
                                    'text-text/40 cursor-not-allowed':
                                        item.disabled,
                                },
                                {
                                    'cursor-pointer underline-hover':
                                        !item.disabled,
                                },
                            ]" v-text="item.text" />
                    </div>
                </template>
            </div>
        </template>
    </ButtonPopover>
</template>

<script>
import ButtonPopover from '@/Components/Utilities/ButtonPopover.vue'
import { PopoverButton } from '@headlessui/vue'
import { PhDotsThreeOutline } from '@phosphor-icons/vue'
import DynamicLink from '@/Components/Utilities/DynamicLink.vue'

export default {
    components: {
        ButtonPopover,
        PhDotsThreeOutline,
        DynamicLink,
        PopoverButton
    },

    props: {
        items: {
            type: Array,
            required: true,
        },
    },
    computed: {
        iconExists() {
            return this.items.some((item) => item.icon)
        },
    },
}
</script>
